'use client';

import type { ActiveMiner } from '@/lib/adminApi';

type Props = {
  miners: ActiveMiner[];
};

function formatRemaining(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${h}h ${m}m`;
}

export default function ActiveMinersTable({ miners }: Props) {
  return (
    <div style={{
      padding: 24,
      background: '#141414',
      border: '1px solid #2A2A2A',
      borderRadius: 14,
    }}>
      <div style={{ marginBottom: 20 }}>
        <h3 style={{
          margin: 0, color: '#F5F5F5',
          fontSize: 16, fontWeight: 700,
        }}>
          Active Miners
        </h3>
        <p style={{
          margin: '4px 0 0', color: '#6B6B6B', fontSize: 12,
        }}>
          {miners.length} user{miners.length !== 1 ? 's' : ''} currently mining
        </p>
      </div>

      {miners.length === 0 ? (
        <div style={{
          padding: '40px 20px',
          textAlign: 'center',
          color: '#6B6B6B',
          fontSize: 13,
        }}>
          No active miners
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 13,
          }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #2A2A2A' }}>
                <th style={th}>USER</th>
                <th style={th}>RATE</th>
                <th style={th}>REMAINING</th>
                <th style={{ ...th, textAlign: 'right' }}>BALANCE</th>
              </tr>
            </thead>
            <tbody>
              {miners.map(m => (
                <tr key={m.id} style={{ borderBottom: '1px solid #1A1A1A' }}>
                  <td style={td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{
                        width: 28, height: 28, borderRadius: 14,
                        background: '#0A0A0A',
                        border: '1px solid #D4AF37',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#D4AF37', fontSize: 11, fontWeight: 700,
                      }}>
                        {m.displayName?.charAt(0).toUpperCase() || 'U'}
                      </div>
                      <div>
                        <div style={{ color: '#F5F5F5', fontWeight: 600 }}>
                          {m.displayName}
                        </div>
                        <div style={{ color: '#6B6B6B', fontSize: 11 }}>
                          {m.email}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={td}>
                    <span style={{ color: '#D4AF37', fontWeight: 600 }}>
                      {m.rate.toFixed(7)}/s
                    </span>
                  </td>
                  <td style={td}>
                    <span style={{ color: '#A0A0A0' }}>
                      {formatRemaining(m.secondsRemaining)}
                    </span>
                  </td>
                  <td style={{ ...td, textAlign: 'right' }}>
                    <span style={{ color: '#F5F5F5', fontWeight: 600 }}>
                      {m.balance.toFixed(2)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const th: React.CSSProperties = {
  padding: '10px 0',
  textAlign: 'left',
  color: '#6B6B6B',
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: 1.5,
};

const td: React.CSSProperties = {
  padding: '14px 0',
};
